module.exports = __webpack_public_path__ + "static/media/info-gray.1524d44e.svg";